/**
 * PhotoPrint mixin
 *
 * Добавляет логику для печати фото
 *
 */

import { PhotoPrinterInfoStates } from '@pb/api/dist/src/services/printer_photo';

export default {
  created() {
    this.initPhotoPrintActions();
  },
  methods: {
    async startPhotoPrint(source) {
      try {
        this.onPhotoPrintStarted?.(); // eslint-disable-line
        await this.$robot.printPhotoService.print(source);
      } catch {
        this.checkPhotoPrintStatus();
      }
    },
    async checkPhotoPrintStatus() {
      try {
        const status = await this.$robot.printPhotoService.status();
        if ([PhotoPrinterInfoStates.Error, PhotoPrinterInfoStates.NotConnected].includes(status)) {
          throw new Error();
        }
      } catch {
        this.onPhotoPrintError?.();
      }
    },
    sendPhotoPrintFinish() {
      return this.onPhotoPrintFinished?.();
    },
    disablePhotoPrint() {
      return this.onNoPrinter?.();
    },
    initPhotoPrintActions() {
      const robotActions = [
        this.$robot.printPhotoService.onNoPrinter(this.disablePhotoPrint),
        this.$robot.printPhotoService.onFinish(this.sendPhotoPrintFinish),
        this.$robot.printPhotoService.onError(this.checkPhotoPrintStatus),
      ];
      this.$robot.printPhotoService.status();
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
